import { render, staticRenderFns, recyclableRender, components } from "./questions-item.vue?vue&type=template&id=5bef46d8&scoped=true&"
var renderjs
import script from "./questions-item.vue?vue&type=script&lang=js&"
export * from "./questions-item.vue?vue&type=script&lang=js&"
import style0 from "./questions-item.vue?vue&type=style&index=0&id=5bef46d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef46d8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/questions-item.vue"
export default component.exports